var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.html
    ? _c(
        _vm.tag,
        {
          tag: "component",
          style: { fontWeight: _vm.bold ? "bold" : undefined },
        },
        [
          _vm.before && _vm.canExpand
            ? _c(
                "button",
                {
                  staticClass: "btn btn-inline btn-link",
                  attrs: {
                    type: "button",
                    "aria-expanded": _vm.expanded.toString(),
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      _vm.expanded = !_vm.expanded
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t(_vm.toggleLabelKey)))]
              )
            : _vm._e(),
          _vm.before ? [_vm._v("…")] : _vm._e(),
          _vm._l(
            _vm.renderInfo,
            function (
              { text, punct, punctBefore, style, title, relationKeys },
              i
            ) {
              return [
                _vm.doPunct && punctBefore
                  ? _c("span", { domProps: { innerHTML: _vm._s(punctBefore) } })
                  : _vm._e(),
                style
                  ? _c("span", {
                      class: {
                        hoverable: true,
                        hover: !!(relationKeys && _vm.hoverMatchInfos)
                          ? relationKeys.some((c) =>
                              _vm.hoverMatchInfos.includes(c)
                            )
                          : false,
                      },
                      style: style,
                      attrs: { title: title },
                      domProps: { innerHTML: _vm._s(text) },
                      on: {
                        mouseover: function ($event) {
                          return _vm.$emit("hover", relationKeys)
                        },
                        mouseout: function ($event) {
                          return _vm.$emit("unhover")
                        },
                      },
                    })
                  : _c("span", { domProps: { innerHTML: _vm._s(text) } }),
                _vm.doPunct
                  ? _c("span", { domProps: { innerHTML: _vm._s(punct) } })
                  : _vm._e(),
              ]
            }
          ),
          _vm.after ? [_vm._v("…")] : _vm._e(),
          !_vm.before && _vm.canExpand
            ? _c(
                "button",
                {
                  staticClass: "btn btn-inline btn-link",
                  attrs: {
                    type: "button",
                    "aria-expanded": _vm.expanded.toString(),
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      _vm.expanded = !_vm.expanded
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t(_vm.toggleLabelKey)))]
              )
            : _vm._e(),
        ],
        2
      )
    : _c(
        _vm.tag,
        {
          tag: "component",
          style: { fontWeight: _vm.bold ? "bold" : undefined },
        },
        [
          _vm.before && _vm.canExpand
            ? _c(
                "button",
                {
                  staticClass: "btn btn-inline btn-link",
                  attrs: {
                    type: "button",
                    "aria-expanded": _vm.expanded.toString(),
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      _vm.expanded = !_vm.expanded
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t(_vm.toggleLabelKey)))]
              )
            : _vm._e(),
          _vm.before ? [_vm._v("…")] : _vm._e(),
          _vm._l(
            _vm.renderInfo,
            function (
              { text, punct, punctBefore, style, title, relationKeys },
              i
            ) {
              return [
                _vm.doPunct && punctBefore
                  ? [_vm._v(_vm._s(punctBefore))]
                  : _vm._e(),
                style
                  ? _c(
                      "span",
                      {
                        class: {
                          hoverable: true,
                          hover: !!(relationKeys && _vm.hoverMatchInfos)
                            ? relationKeys.some((c) =>
                                _vm.hoverMatchInfos.includes(c)
                              )
                            : false,
                        },
                        style: style,
                        attrs: { title: title },
                        on: {
                          mouseover: function ($event) {
                            return _vm.$emit("hover", relationKeys)
                          },
                          mouseout: function ($event) {
                            return _vm.$emit("unhover")
                          },
                        },
                      },
                      [_vm._v(_vm._s(text))]
                    )
                  : [_vm._v(_vm._s(text))],
                _vm.doPunct ? [_vm._v(_vm._s(punct))] : _vm._e(),
              ]
            }
          ),
          _vm.after ? [_vm._v("…")] : _vm._e(),
          !_vm.before && _vm.canExpand
            ? _c(
                "button",
                {
                  staticClass: "btn btn-inline btn-link",
                  attrs: {
                    type: "button",
                    "aria-expanded": _vm.expanded.toString(),
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      _vm.expanded = !_vm.expanded
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t(_vm.toggleLabelKey)))]
              )
            : _vm._e(),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }